import { Outlet } from "react-router-dom"

export function AuthLayout() {
  return (
    <div className="auth-layout">
      {/* <header className="auth-layout__header">
        <p className="eyebrow">Senzo · Admin</p>
      </header> */}
      <main className="auth-layout__content">
        <Outlet />
      </main>
    </div>
  )
}
